// @generated by TypeGen from LogbookModel/Status/ShipStatus.swift - DO NOT EDIT

export interface IShipStatusData {
  location?: string;
  crewOffboard?: boolean;
}

export enum IShipStatus {
  none = -1,
  inmotion = 0,
  drifting = 1,
  port = 2,
  anchor = 3,
  buoy = 4,
  bunkering = 5,
  lock = 6,
  bridge = 7,
  waiting = 8,
}
